<template>
<div id="unsubscribe">
    Вы были успешно отписаны от нашей рассылки, приносим извенения за неудобства.
</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'unsubscribe',
  created () {
    let email = this.$route.params.email
    axios.get('https://crm.v-avtoservice.com/api/unsubscribe?email=' + email)
  },
  watch: {
    $route (to, from) {
      let email = to.params.email
      axios.get('https://crm.v-avtoservice.com/api/unsubscribe?email=' + email)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/unsubscribe.vue